import { __exports as careTechClient } from './_virtual-careTechClient.js';
import { __require as requireLogger } from './vp-js-token-engine-build-infrastructure-logger.js';

var hasRequiredCareTechClient;

function requireCareTechClient () {
	if (hasRequiredCareTechClient) return careTechClient;
	hasRequiredCareTechClient = 1;

	Object.defineProperty(careTechClient, "__esModule", {
	  value: true
	});
	careTechClient.getContactUsPage = careTechClient.getCarePhoneData = void 0;
	var _logger = requireLogger();
	const careTechUrl = 'https://channel-provider-service.care.vpsvc.com';
	const getCarePhoneData = async (locale, tenant) => {
	  try {
	    const url = "".concat(careTechUrl, "/v2/phone/?tenant=").concat(tenant.toLowerCase(), "&locale=").concat(locale.toLowerCase(), "&requestor=token-engine");
	    const response = await fetch(url);
	    return response.json();
	  } catch (e) {
	    _logger.logger.error("The request for tenant ".concat(tenant, " and ").concat(locale, " to url: ").concat(careTechUrl, ". Returned error ").concat(e.stack), {
	      contextData: {
	        stack: e.stack,
	        culture: locale,
	        tenant
	      }
	    });
	    throw e;
	  }
	};
	careTechClient.getCarePhoneData = getCarePhoneData;
	const getContactUsPage = async (locale, tenant) => {
	  try {
	    const url = "".concat(careTechUrl, "/v2/contact_us_page?tenant=").concat(tenant.toLowerCase(), "&locale=").concat(locale.toLowerCase(), "&requestor=token-engine");
	    const response = await fetch(url);
	    return response.json();
	  } catch (e) {
	    _logger.logger.error("The request for tenant ".concat(tenant, " and ").concat(locale, " to url: ").concat(careTechUrl, ". Returned error ").concat(e.stack), {
	      contextData: {
	        stack: e.stack,
	        culture: locale,
	        tenant
	      }
	    });
	    throw e;
	  }
	};
	careTechClient.getContactUsPage = getContactUsPage;
	
	return careTechClient;
}

export { requireCareTechClient as __require };
//# sourceMappingURL=vp-js-token-engine-build-services-careTechClient.js.map
